// removed by extract-text-webpack-plugin
module.exports = {"root":"_3grfhjfQve7UNwCqTF8cJH","required":"_1Pm0IiE8M7U3Xlg66DQQB-","icon":"_3XMs27B4hrtDZZM4tm-dzt"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/FieldLabelAttributes/FieldLabelAttributes.scss
// module id = ./node_modules/wix-style-react/dist/es/src/FieldLabelAttributes/FieldLabelAttributes.scss
// module chunks = 0